export const experienceYears = [
  { value: "none", labelKey: "onboarding.experience.none" },
  { value: "under-1", labelKey: "onboarding.experience.under1" },
  { value: "1-3", labelKey: "onboarding.experience.oneToThree" },
  { value: "3-5", labelKey: "onboarding.experience.threeToFive" },
  { value: "5-plus", labelKey: "onboarding.experience.fivePlus" },
] as const;

export const careEnvironments = [
  { value: "po-onderbouw", labelKey: "onboarding.careEnvironments.thuiszorg" },
  { value: "po-bovenbouw", labelKey: "onboarding.careEnvironments.wonen" },
  { value: "vo-onderbouw", labelKey: "onboarding.careEnvironments.dagbesteding" },
  { value: "vo-bovenbouw", labelKey: "onboarding.careEnvironments.verpleeghuis" },
  { value: "sbo", labelKey: "onboarding.careEnvironments.ziekenhuis" },
  { value: "groep-waterkant", labelKey: "onboarding.careEnvironments.wonenWaterkant" },
  { value: "groep-de-linde", labelKey: "onboarding.careEnvironments.wonenDeEs" },
] as const;

/** Passport domain labels aligned with the starter-teacher catalogue (CAP-01…CAP-08). */
export const experienceDomains = [
  { value: "CAP-01", labelKey: "onboarding.domains.cap01" },
  { value: "CAP-04", labelKey: "onboarding.domains.cap04" },
  { value: "CAP-03", labelKey: "onboarding.domains.cap03" },
  { value: "CAP-06", labelKey: "onboarding.domains.cap06" },
  { value: "CAP-02", labelKey: "onboarding.domains.cap02" },
  { value: "CAP-05", labelKey: "onboarding.domains.cap05" },
  { value: "CAP-07", labelKey: "onboarding.domains.cap07" },
  { value: "CAP-08", labelKey: "onboarding.domains.cap08" },
] as const;

export const workChallenges = [
  { value: "time-pressure", labelKey: "onboarding.challenges.timePressure" },
  { value: "complex-care", labelKey: "onboarding.challenges.complexCare" },
  { value: "protocols", labelKey: "onboarding.challenges.protocols" },
  { value: "communication", labelKey: "onboarding.challenges.communication" },
  { value: "confidence", labelKey: "onboarding.challenges.confidence" },
  { value: "teamwork", labelKey: "onboarding.challenges.teamwork" },
] as const;
